import { LOCAL_STORAGE_KEY_JWT } from '@/api'
import { MissionHeader } from '@/features/missions/components/MissionHeader'
import { MissionsUrlProvider } from '@/features/missions/context/MissionsUrlProvider'
import { MissionsForAuthorizedUser, MissionsForUnauthorizedUser } from '@/features/missions/MissionsWrappers'
import { Page } from '@/ui-kit'
import { useLocalStorage } from '@/utils/useLocalStorage'

const MissionsPage = () => {
  const [jwt] = useLocalStorage(LOCAL_STORAGE_KEY_JWT, '')

  return (
    <MissionsUrlProvider isWebview={false}>
      <Page>
        <div className="flex flex-col gap-8 py-8">
          <MissionHeader />
          {jwt ? <MissionsForAuthorizedUser /> : <MissionsForUnauthorizedUser />}
        </div>
      </Page>
    </MissionsUrlProvider>
  )
}

export default MissionsPage
